import React, { useState, useEffect } from 'react';
import {
    CCard,
    CCardBody,
    CCardTitle,
    CCardText,
    CFormTextarea,
    CButton,
    CRow,
    CCol,
    CFormCheck,
} from '@coreui/react';
import DatePicker from 'react-date-picker';
import Multiselect from 'multiselect-react-dropdown';
import CookieFunctions from '../functions/CookieFunctions';
import { toast } from 'react-toastify';

export default function Safety() {

    const [body, setBody] = useState("");
    const [expiration, setExpiration] = useState(new Date());
    const [showOn, setShowOn] = useState({
        isaac: true,
        tv: true, // bolton tv
        windsorTv: true,
        dp: true // driver portal
    })
    const [errors, setErrors] = useState([]);

    const [options, setOptions] = useState([]);
    const [selected, setSelected] = useState([]);

    const [isSending, setIsSending] = useState(false);

    function getGroups() {
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        fetch("/api/safety/groups/get",
            {
                method: 'GET',
                headers: myHeaders
            }
        ).then((res) => {
            if (res.ok) {
                return res.json()
            } else if (res.status === 400) {
                throw res.text()
            }
        }).then((data) => {
            setOptions(data)
            setSelected(data)
        }).catch((e) => {
            toast.error(e, {
                closeButton: true,
                autoClose: true,
                position: toast.POSITION.BOTTOM_CENTER,
                theme: "colored",

            })
        })
    }

    function onChange(selectedList, selectedItem) {
        setSelected(selectedList)

    }

    function sendMessage() {
        setErrors([])
        setIsSending(true)

        let tempErrors = []

        // Check values are not null 
        if (expiration === null) tempErrors.push("Must select an expiry date")
        if (!showOn.isaac && !showOn.dp && !showOn.tv && !showOn.windsorTv) tempErrors.push("Must select at least one of the 4 options: Isaac, Bolton TV, Windsor TV, Driver Portal")
        if (selected.length === 0) tempErrors.push("Must select at least one group")
        if (body === "") tempErrors.push("Must input a message")

        if (tempErrors.length > 0) {
            setErrors(tempErrors)
            setIsSending(false)
            return
        }

        // create the headers for the fetch 
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        const formData = new FormData();
        formData.append("isaac", showOn.isaac)
        formData.append("tv", showOn.tv)
        formData.append("windsorTv", showOn.windsorTv)
        formData.append("dp", showOn.dp)
        formData.append("content", body)
        formData.append("expiry", new Date(expiration).toDateString())
        formData.append("groups", selected.map((a) => a.abbr))

        fetch("/api/safety/message/send",
            {
                headers: myHeaders,
                method: 'POST',
                body: formData
            }
        ).then((res) => {
            if (res.ok) {
                toast.success("Message has been posted!", {
                    closeButton: true,
                    autoClose: true,
                    position: toast.POSITION.BOTTOM_CENTER,
                    theme: "colored",

                })
                setBody("")
            } else {
                throw new Error()
            }
        }).finally(_ => {
            setIsSending(false)
        })
    }

    useEffect(() => {
        getGroups()
    }, [])

    return (
        <CCard className="mb-4">
            <CCardBody>
                <CCardTitle className='fs-2'>Send a Message</CCardTitle>

                <CRow className="my-2">
                    <CCol sm="12" md="4" className="my-1" style={{ display: 'flex', justifyContent: 'start' }}>
                        <CCardText className='fs-5' style={{ margin: '8px' }}>Expiration</CCardText>
                        <DatePicker
                            id='date-picker'
                            className='form-control'
                            value={expiration}
                            onChange={(date) => { setExpiration(date) }}
                            locale='en-ca'
                            format='yy-MM-dd'
                            minDetail='year'
                            yearPlaceholder='yyyy'
                            monthPlaceholder='mm'
                            dayPlaceholder='dd'
                            minDate={new Date()}
                            defaultValue={new Date()}
                        />
                    </CCol>
                    <CCol sm="4" md="2" style={{ margin: 'auto' }} >
                        <CFormCheck
                            className='fs-5'
                            label="Isaac"
                            checked={showOn["isaac"]}
                            onChange={(e) => {
                                setShowOn((prev) => ({
                                    ...prev,
                                    isaac: e.target.checked
                                }))
                            }}
                        />
                    </CCol>
                    <CCol sm="4" md="2" style={{ margin: 'auto' }}>
                        <CFormCheck
                            className='fs-5'
                            label="Bolton TV"
                            checked={showOn["tv"]}
                            onChange={(e) => {
                                setShowOn((prev) => ({
                                    ...prev,
                                    tv: e.target.checked
                                }))
                            }}
                        />
                    </CCol>
                    <CCol sm="4" md="2" style={{ margin: 'auto' }}>
                        <CFormCheck
                            className='fs-5'
                            label="Windsor TV"
                            checked={showOn["windsorTv"]}
                            onChange={(e) => {
                                setShowOn((prev) => ({
                                    ...prev,
                                    windsorTv: e.target.checked
                                }))
                            }}
                        />
                    </CCol>
                    <CCol sm="4" md="2" style={{ margin: 'auto' }}>
                        <CFormCheck
                            className='fs-5'
                            label="Driver Portal"
                            checked={showOn["dp"]}
                            onChange={(e) => {
                                setShowOn((prev) => ({
                                    ...prev,
                                    dp: e.target.checked
                                }))
                            }}
                        />
                    </CCol>
                </CRow>

                <Multiselect
                    showCheckbox
                    isObject={true}
                    displayValue='name'
                    selectedValues={options}
                    onRemove={onChange}
                    onSelect={onChange}
                    options={options}
                    placeholder='Select groups...'
                />

                <CFormTextarea
                    placeholder="Type your message here (maximum 1000 characters)"
                    value={body}
                    onChange={(e) => { setBody(e.target.value) }}
                    style={{ marginBottom: '10px', marginTop: '8px', minHeight: '200px' }}
                />
                {errors.length !== 0 ?
                    <CCol sm="12">
                        {errors.map((error, i) => {
                            return <CCardText key={i} style={{ color: 'red', fontWeight: '600', fontSize: '20px' }}>{error}</CCardText>
                        })}
                    </CCol> : null}

                <CButton
                    color="primary"
                    className="mt-3"
                    onClick={sendMessage}
                    disabled={isSending}
                >
                    Submit
                </CButton>
            </CCardBody>
        </CCard>
    );
}
